import {
   OBTER_CARGOS,
   OBTER_PATIOS,
   OBTER_UNIDADE_LOTACAO,
   SET_GERAR_RELATORIO,
   SET_GERAR_RELATORIO_USU_DELEGACAO,
   SET_OBTER_RELATORIOS,
   SET_REPROCESSAR_RELATORIO
} from './mutations-types'

export default {
   [SET_OBTER_RELATORIOS](state, payload) {
      if (payload) {
         state.items = payload.items
         state.paginaAtual = payload.paginaAtual
         state.totalDePaginas = payload.totalDePaginas
         state.registrosPorPagina = payload.registrosPorPagina
         state.totalDeRegistros = payload.totalDeRegistros
         state.possuiPaginaAnterior = payload.possuiPaginaAnterior
         state.possuiProximaPagina = payload.possuiProximaPagina
         state.codigo = payload.codigo
         state.sucesso = payload.sucesso
         state.mensagens = payload.mensagens
      } else {
         state.items = null
      }
   },

   [SET_REPROCESSAR_RELATORIO](state, payload) {},

   [SET_REPROCESSAR_RELATORIO](state, payload) {},

   [SET_GERAR_RELATORIO](state, payload) {
      state.relatorio = payload
   },

   [OBTER_CARGOS](state, payload) {
      state.cargos = payload.items
   },

   [OBTER_UNIDADE_LOTACAO](state, payload) {
      state.unidadeLotacao = payload.items
   },

   [OBTER_PATIOS](state, payload) {
      state.patios = payload.items
   },

   [SET_GERAR_RELATORIO_USU_DELEGACAO](state, payload) {
      state.relatorioUsuDelegacao = payload
   }
}
